import { AuerState } from "@auer-steel/Store/AuerState";
import updateRmaForm from "@auer-steel/Store/Pages/RequestRma/Handlers/UpdateRmaForm";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { RequestRmaPageContext } from "@insite/content-library/Pages/RequestRmaPage";
import TextField from "@insite/mobius/TextField";
import React, { FC } from "react";
import { connect, ResolveThunks } from "react-redux";

const mapStateToProps = (state: AuerState) => {
    return {
        rmaFormState: state.auerRequestRma.formState,
    };
};

const mapDispatchToProps = {
    updateRmaForm,
};

type Props = WidgetProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const Input: FC<Props> = props => {
    if (!props.rmaFormState.isWarrantyClaim) {
        return null;
    }
    const valueChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        props.updateRmaForm({
            ...props.rmaFormState,
            homeownerName: value,
        });
    };
    return (
        <StyledWrapper>
            <TextField
                value={props.rmaFormState.homeownerName}
                label={translate("Homeowner Name")}
                onChange={valueChanged}
            ></TextField>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(Input),
    definition: {
        allowedContexts: [RequestRmaPageContext],
        group: "Return Request (RMA)",
        displayName: "Homeowner Name",
    },
};

export default widgetModule;
